import { LogManager } from "aurelia-framework";
export var applicationLogger = LogManager.getLogger('sanistar-remote');